import script from "./FormTextInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./FormTextInput.vue?vue&type=script&lang=ts&setup=true"

import "./FormTextInput.vue?vue&type=style&index=0&id=61b3c392&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61b3c392"]])

export default __exports__